import { render, staticRenderFns } from "./DailyActivity.vue?vue&type=template&id=28a38276"
import script from "./DailyActivity.vue?vue&type=script&lang=js"
export * from "./DailyActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports